import Card from "../../../../../shared/components/Card";
import PrimaryIcon from "../../../../../shared/components/PrimaryIcon";
import type { MetaIcon } from "../../../../../shared/constants/icon.constant";

interface AccountWalletCardProps {
  title: string;
  icon: MetaIcon;
  value: string;
}

export default function AccountWalletCard({
  title,
  icon,
  value,
}: Readonly<AccountWalletCardProps>) {
  return (
    <Card
      title={title}
      titleSize="xs"
      className="text-label-dark! font-semibold">
      <div className="flex gap-2 items-center">
        <PrimaryIcon icon={icon} />
        <div className="text-lg text-white">{value}</div>
      </div>
    </Card>
  );
}
